import React, { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL } from "../../config";
import Pagination from "../Pagination/Paginations.js";
import DownloadButtons from "../DownloadButtons/DownloadButtons";
import EntriesSelector from "../Pagination/EntriesSelector";
import Select from 'react-select';
import DatePicker from "react-datepicker";
const AttendanceBriefReport = () => {
  const today = new Date().toISOString().split("T")[0];
  const [formData, setFormData] = useState({
    from_date: today,
    to_date: today,
    dept_id: "",
  });

  const [loading, setLoading] = useState(false);
  const [report, setReport] = useState([]);
  const [dates, setDates] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(50);
  const [searchTerm, setSearchTerm] = useState("");

  // 🔹 Fetch departments
  const handleDepartment = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/showdepartment`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });
      setDepartments(res.data);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load departments");
    }
  };

  useEffect(() => {
    handleDepartment();
  }, []);

  // 🔹 Handle input change
  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

 const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    const res = await axios.post(
      `${API_BASE_URL}/attendanceBrief`,
      formData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      }
    );

    setReport(Object.values(res.data.records));
    setDates(res.data.dates);
  } catch (err) {
    toast.error("Failed to fetch report");
  }

  setLoading(false);
};

  // 🔹 Generate flattened data for CSV/PDF download
  const generateFlatData = () => {
    return report.map((emp) => {
      let present = 0,
        absent = 0,
        weekoff = 0,
        cl = 0,
        sl = 0,
        lop = 0,
        comp = 0,
        mat = 0,
        spl = 0,
        pl = 0,
        hd = 0,
        holi = 0;

      const flatAttendance = {};
      dates.forEach((date) => {
        const val = emp.attendance?.[date]?.in || "A";
        flatAttendance[new Date(date).toLocaleDateString("en-GB")] = val;

        if (val === "P") present++;
        else if (val === "H") holi++;
        else if (val === "WO") weekoff++;
        else if (val === "CL") cl++;
        else if (val === "SL") sl++;
        else if (val === "LOP") lop++;
        else if (val === "CO") comp++;
        else if (val === "MATL") mat++;
        else if (val === "SPL") spl++;
        else if (val === "PL") pl++;
        else if (val === "HD") hd++;
        else absent++;
      });

      return {
        "Emp ID": emp.employee_id,
        "Employee Name": emp.employee_name,
        Department: emp.department,
        "Date of Joining": emp.date_of_joining,
        ...flatAttendance,
        Present: present,
        Holidays: holi,
        Absent: absent,
        "Week Off": weekoff,
        "CL Leave": cl,
        "SL Leave": sl,
        LOP: lop,
        "COMP OFF": comp,
        "MAT Leave": mat,
        "SPL Leave": spl,
        "PL Leave": pl,
        "HD Leave": hd,
        "Payable Days":
          present +
          weekoff +
          holi +
          cl +
          sl +
          comp +
          mat +
          spl +
          pl +
          hd,
        "Available CL": emp.leave_available,
        "Available SL": emp.sick_leave_available,
      };
    });
  };

  // 🔹 Pagination logic
  const totalPages = Math.ceil(report.length / entriesPerPage);
  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;
  const currentRecords = report.slice(indexOfFirst, indexOfLast);

  // 🔹 Search filter
  const filteredRecords = currentRecords.filter((emp) =>
    emp.employee_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="container mt-4">
     <ToastContainer position="bottom-right" />
      <div className="card shadow">
        <div className="card-header">
          <h3 className="card-title text-primary mb-0">
            Attendance Brief Report
          </h3>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit} className="row g-3">
            <div className="col-md-3">
  <label>From Date</label>

  <DatePicker
    selected={formData.from_date ? new Date(formData.from_date) : null}
    onChange={(date) => {
      const value = date
        ? date.toLocaleDateString("en-CA")
        : "";

      setFormData((prev) => ({ ...prev, from_date: value }));
    }}
    dateFormat="yyyy-MM-dd"
    placeholderText="Select From Date"
    className="form-control"
    maxDate={formData.to_date ? new Date(formData.to_date) : null}
  />
</div>

            <div className="col-md-3">
  <label>To Date</label>

  <DatePicker
    selected={formData.to_date ? new Date(formData.to_date) : null}
    onChange={(date) => {
      const value = date
        ? date.toLocaleDateString("en-CA")
        : "";

      setFormData((prev) => ({ ...prev, to_date: value }));
    }}
    dateFormat="yyyy-MM-dd"
    placeholderText="Select To Date"
    className="form-control"
    minDate={formData.from_date ? new Date(formData.from_date) : null}
  />
</div>

            <div className="col-md-3">
              <label>Department</label>
               <Select
    name="dept_id"
    value={departments
      .map((dept) => ({
        value: dept.department_id,
        label: dept.department_name,
      }))
      .find((d) => d.value === formData.dept_id) || null}
    onChange={(selected) =>
      handleChange({
        target: { name: "dept_id", value: selected ? selected.value : "" },
      })
    }
    options={departments.map((dept) => ({
      value: dept.department_id,
      label: dept.department_name,
    }))}
    isClearable
    placeholder="All"
    className="basic-single"
  />
            </div>
            <div className="col-md-3 d-flex align-items-end">
              <button className="btn btn-danger w-100" type="submit">
                {loading ? "Loading..." : "Get"}
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* 🔹 Controls */}
      <div
  className="d-flex flex-wrap align-items-center justify-content-between my-3"
  style={{ gap: "1rem" }}
>
  {/* Left section — CSV/PDF download + Show entries */}
  <div className="d-flex align-items-center gap-3">
   <DownloadButtons data={generateFlatData()} filename="Attendance_Brief_Report" />

    <EntriesSelector
      entriesPerPage={entriesPerPage}
      setEntriesPerPage={setEntriesPerPage}
      setCurrentPage={setCurrentPage}
    />
  </div>

  {/* Right section — Search bar */}
  <div style={{ width: "250px" }}>
    <input
      type="text"
      placeholder="Search employee..."
      value={searchTerm}
      onChange={(e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
      }}
      className="form-control"
    />
  </div>
</div>


      {/* 🔹 Report Table */}
      <div className="card mt-4">
        <div className="card-body table-responsive">
          {loading && <p className="text-center text-info">Loading...</p>}

          {!loading && report.length > 0 ? (
            <table className="table table-bordered text-center">
              <thead style={{ backgroundColor: "#7d858369" }}>
                <tr
                  
                >
                  <th>Emp ID</th>
                  <th>Employee</th>
                  <th>Department</th>
                  <th>DOJ</th>

                  {dates.map((d, i) => (
                    <th
                      key={i}
                     
                    >
                      {new Date(d).toLocaleDateString("en-GB")}
                    </th>
                  ))}

                  <th>Present</th>
                  <th>Holidays</th>
                  <th>Absent</th>
                  <th>Week Off</th>
                  <th>CL Leave</th>
                  <th>SL Leave</th>
                  <th>LOP</th>
                  <th>COMP OFF</th>
                  <th>MAT Leave</th>
                  <th>SPL Leave</th>
                  <th>PL Leave</th>
                  <th>HD Leave</th>
                  <th>Payable Days</th>
                  <th>Available CL</th>
                  <th>Available SL</th>
                  <th>Manual Updates</th>
                </tr>
              </thead>

              <tbody>
                {filteredRecords.map((emp, i) => {
                  let present = 0,
                    absent = 0,
                    weekoff = 0,
                    cl = 0,
                    sl = 0,
                    lop = 0,
                    comp = 0,
                    mat = 0,
                    spl = 0,
                    pl = 0,
                    hd = 0,
                    holi = 0;

                  return (
                    <tr key={i}>
                      <td>{emp.employee_id}</td>
                      <td>{emp.employee_name}</td>
                      <td>{emp.department}</td>
                      <td>{emp.date_of_joining}</td>

                      {dates.map((date, j) => {
                        const val = emp.attendance?.[date]?.in || "A";
                        if (val === "P") present++;
                        else if (val === "H") holi++;
                        else if (val === "WO") weekoff++;
                        else if (val === "CL") cl++;
                        else if (val === "SL") sl++;
                        else if (val === "LOP") lop++;
                        else if (val === "CO") comp++;
                        else if (val === "MATL") mat++;
                        else if (val === "SPL") spl++;
                        else if (val === "PL") pl++;
                        else if (val === "HD") hd++;
                        else absent++;

                        return <td key={j}>{val}</td>;
                      })}

                      <td>{present}</td>
                      <td>{holi}</td>
                      <td>{absent}</td>
                      <td>{weekoff}</td>
                      <td>{cl}</td>
                      <td>{sl}</td>
                      <td>{lop}</td>
                      <td>{comp}</td>
                      <td>{mat}</td>
                      <td>{spl}</td>
                      <td>{pl}</td>
                      <td>{hd}</td>
                      <td>
                        {present +
                          weekoff +
                          holi +
                          cl +
                          sl +
                          comp +
                          mat +
                          spl +
                          pl +
                          hd}
                      </td>
                      <td>{emp.leave_available}</td>
                      <td>{emp.sick_leave_available}</td>
                      <td>{emp.manual_count || 0}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            !loading && (
              <p className="text-center text-muted">No records found</p>
            )
          )}
        </div>
      </div>
       <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
    </div>
  );
};

export default AttendanceBriefReport;
